/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { cn } from "../../lib/utils";

/**
 * The manatee face from the wordmark, on its own. With `animate`, the strokes
 * draw themselves in and the eyes pop — used where the console wants a moment
 * of warmth (login, empty states). Inherits `currentColor`.
 */
export function ManateeMark({ animate = false, className }: { animate?: boolean; className?: string }) {
  const draw = (delay: string) => ({ "--draw-delay": delay }) as React.CSSProperties;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="28 18 338 250"
      role="img"
      aria-label="Manatee"
      className={cn("manatee-mark h-12 w-auto", animate && "manatee-mark-animate", className)}
    >
      <g fill="none" stroke="currentColor" strokeWidth="18" strokeLinecap="butt" strokeLinejoin="round">
        <path data-draw pathLength={1} style={draw("0s")} d="M53 179 A144 144 0 0 1 341 179" />
        <path data-draw pathLength={1} style={draw("0.55s")} d="M197 178 V208" />
        <path
          data-draw
          pathLength={1}
          style={draw("0.7s")}
          d="M95 222 C111 244 132 251 150 251 C174 251 190 237 197 210"
        />
        <path
          data-draw
          pathLength={1}
          style={draw("0.7s")}
          d="M299 222 C283 244 262 251 244 251 C220 251 204 237 197 210"
        />
      </g>
      <g fill="currentColor" stroke="none">
        <circle data-pop style={draw("1.15s")} cx="197" cy="210" r="3" />
        <circle data-pop style={draw("1.25s")} cx="144" cy="140" r="13" />
        <circle data-pop style={draw("1.35s")} cx="250" cy="140" r="13" />
      </g>
    </svg>
  );
}
